import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import GlobalSelectField from '../../../../components/mui/GlobalSelectField';
import { Field, Form, FormikProvider, useFormik } from 'formik';
import * as yup from 'yup';
import { EXPIRING_STATUS } from '../utils/constaints';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
import { updateExpiringAdmissionStatus } from '../../../../redux/features/crdMigrationSlice';

export default function ChangeExpiringAdmissionStatus({ setOpenModalState, row, setRefresh }) {
  const submitLoading = useSelector((state) => state.crdMigration.submitLoading);
  const dispatch = useDispatch();
  const apiHelper = useHandleApiResponse();

  const submitHanlder = (values) => {
    dispatch(updateExpiringAdmissionStatus(values)).then((res) =>
      apiHelper(res, {
        onSuccess: () => {
          setOpenModalState(false);
          setRefresh((prev) => !prev);
        },
      }),
    );
  };

  const validationSchema = yup.object({
    status: yup.string().required('Status is Required'),
    remarks: yup.string().required('Remarks is required').min(4, 'minimum 4 character needed'),
  });
  const formik = useFormik({
    initialValues: {
      course_enrollment_id: row?.course_enrollment_id,
      status: row?.expiring_admission_status ?? '',
      remarks: row?.expiring_admission_remarks ?? '',
    },
    validationSchema,
    onSubmit: submitHanlder,
  });

  return (
    <FormikProvider value={formik}>
      <Form>
        <Stack gap={2}>
          <GlobalSelectField
            options={{
              label: 'status',
              data: EXPIRING_STATUS,
              name: 'status',
              formik,
              keys: {
                id: 'id',
                value: 'label',
              },
              setFieldName: 'label',
            }}
          />
          <Field
            as={TextField}
            name="remarks"
            label="Remarks"
            multiline
            rows={3}
            error={formik.touched.remarks && Boolean(formik.errors.remarks)}
            helperText={formik.touched.remarks && formik.errors.remarks}
          />
          <Button variant="contained" type="submit" sx={{ alignSelf: 'flex-end' }} disabled={submitLoading}>
            {submitLoading ? 'Updating...' : 'Update'}
          </Button>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
